import {IconButton, makeStyles} from '@material-ui/core'
import {AccountCircle} from '@material-ui/icons'
import React, {SyntheticEvent} from 'react'

interface HProduceAccountButtonProps {
  onClick: (event: SyntheticEvent<EventTarget>) => void
  iconButtonClassName?: string
}

const useStyles = makeStyles((theme) => ({
  fill: {
    fill: theme.palette.background.default
  }
}))

const HProduceAccountButton: React.FC<HProduceAccountButtonProps> = ({
  onClick,
  iconButtonClassName
}) => {
  const classes = useStyles()

  return (
    <IconButton onClick={onClick} className={iconButtonClassName} data-test-id="account-menu-icon">
      <AccountCircle fill={classes.fill} />
    </IconButton>
  )
}

export default HProduceAccountButton
